/* Assets/page-loader.js — Loader with cart-drawer safety + "{# #}" cleanup
   Short-display version (~0.25s to ~0.9s total). */

(function () {
  const overlay = document.getElementById('page-loader');
  if (!overlay) return;

  /* ---------------- Config (shorter times) ---------------- */
  // Show just enough to feel responsive, but not slow
  const MIN_VISIBLE_MS = 250; // minimum ~0.25s
  const MAX_VISIBLE_MS = 900; // hard cap ~0.9s
  const START_TIME = Date.now();

  /* ---------------- Utils ---------------- */
  const show = () => overlay.classList.remove('pl-hidden');
  const hide = () => overlay.classList.add('pl-hidden');

  // Remove stray "{# ... #}" fragments (from non-Liquid comment syntax)
  function removeTwigyComments(root) {
    const walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    const re = /\{#.*?#\}/g;
    const toClean = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      if (re.test(n.nodeValue)) toClean.push(n);
    }
    toClean.forEach(n => {
      n.nodeValue = n.nodeValue.replace(re, '').trim();
      if (!n.nodeValue) n.parentNode && n.parentNode.removeChild(n);
    });
  }

  function cartDrawerPresent() {
    return (
      document.querySelector('cart-drawer') ||
      document.getElementById('CartDrawer') ||
      document.querySelector('[aria-controls*="CartDrawer"]') ||
      document.querySelector('.cart-drawer, .drawer--cart')
    );
  }

  function isCartRelated(el) {
    if (!el) return false;
    const a = el.closest('a, button, form');
    if (!a) return false;

    if (
      a.matches(
        '[data-cart-drawer-toggle], .header__icon--cart, [aria-controls*="CartDrawer"], button[name="cart"], [data-open-cart]'
      )
    ) return true;

    const href = a.getAttribute && a.getAttribute('href');
    if (href && /\/cart(?:\?|#|$)/.test(href) && cartDrawerPresent()) return true;

    return false;
  }

  function shouldTriggerLoaderFromLink(a) {
    if (!a) return false;
    if (a.hasAttribute('data-no-loader')) return false;
    if (isCartRelated(a)) return false;

    if (a.target && a.target.toLowerCase() === '_blank') return false;
    const href = a.getAttribute('href') || '';
    if (!href || href === '#' || href.startsWith('#')) return false;

    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      if (a.closest('[data-no-loader], .no-loader, .js-no-loader')) return false;
      if (a.matches('[data-action*="add-to-cart"]')) return false;
      return true;
    } catch { return false; }
  }

  function shouldTriggerLoaderFromForm(form) {
    if (!form) return false;
    if (form.hasAttribute('data-no-loader')) return false;
    if (isCartRelated(form)) return false;
    return true;
  }

  /* ---------------- Init ---------------- */
  // Start visible (ensures overlay paints even on super-fast pages)
  show();

  // Prefer earliest safe hide (DOMContentLoaded), still respecting MIN_VISIBLE_MS
  function scheduleHideNowish() {
    const elapsed = Date.now() - START_TIME;
    const delay = Math.max(0, MIN_VISIBLE_MS - elapsed);
    setTimeout(hide, delay);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // DOM is ready or fully loaded—hide asap after min time
    scheduleHideNowish();
  } else {
    // Hide as soon as DOM is interactive (earlier than 'load')
    document.addEventListener('DOMContentLoaded', scheduleHideNowish, { once: true });
    // Absolute failsafe so it never lingers
    setTimeout(hide, MAX_VISIBLE_MS);
  }

  // Back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) hide();
  });

  // Clean stray "{# ... #}" text
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      removeTwigyComments(document.body);
    });
  } else {
    removeTwigyComments(document.body);
  }

  /* ---------------- Cart Drawer Safety ---------------- */
  const drawersToWatch = ['cart-drawer', '.cart-drawer', '.drawer--cart', '#CartDrawer'];
  drawersToWatch.forEach(sel => {
    const el = document.querySelector(sel);
    if (!el) return;
    const mo = new MutationObserver(() => hide());
    mo.observe(el, { attributes: true, childList: true, subtree: true });
  });

  const drawerEvents = ['cart:open', 'cart-drawer:open', 'drawer:open', 'toggleCartDrawer'];
  drawerEvents.forEach(evt => {
    window.addEventListener(evt, hide, true);
    document.addEventListener(evt, hide, true);
  });

  /* ---------------- Navigation Triggers ---------------- */
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a, button');
    if (!a) return;
    if (e.defaultPrevented || (e.type === 'click' && e.button !== 0) ||
        e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    if (isCartRelated(a)) { hide(); return; }
    if (a.tagName === 'A' && shouldTriggerLoaderFromLink(a)) {
      // make overlay visible immediately (fresh start) but overall we cap with MAX_VISIBLE_MS
      overlay.classList.remove('pl-hidden');
      // cap in case navigation returns quickly (e.g., cached pages)
      setTimeout(hide, MAX_VISIBLE_MS);
    }
  }, { capture: true });

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (shouldTriggerLoaderFromForm(form)) {
      overlay.classList.remove('pl-hidden');
      setTimeout(hide, MAX_VISIBLE_MS);
    }
  }, { capture: true });

})();
